import { render, staticRenderFns } from "./DefaultNotificationAction.vue?vue&type=template&id=59acc4e3&scoped=true&"
import script from "./DefaultNotificationAction.vue?vue&type=script&lang=ts&"
export * from "./DefaultNotificationAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59acc4e3",
  null
  
)

export default component.exports